<template>
  <el-dialog :visible.sync="dialogVisible" width="50%" :show-close="false" @close="handleClose"
    :close-on-click-modal="false">
    <div class="flex">
      <div class="padding-bottom-100 radius-30 flex-sub" style="background: #ff9538">
        <div class="padding-lr-30 flex justify-between align-center solid-bottom h-70 text-main">
          <span class="text-18">{{ wordData?.current_index }}/{{ wordData?.total }}</span>
          <span class="text-20">{{ title }}</span>
          <i class="el-icon-close" @click="handleClose"></i>
        </div>
        <div class="text-center padding-tb-100">
          <div class="text-70 definition-content">
            {{ wordData.definition || (wordData.vocabulary_info && wordData.vocabulary_info.definition) || "" }}
          </div>
          <img src="@/assets/icon20.png" class="w-55 h-50 margin-top-60" @click="playAudio" />
        </div>
      </div>
      <div class="flex align-center justify-center flex-direction padding-left-70">
        <img src="@/assets/icon22.png" class="icon-60" @click="handleCryingFace" />
        <img src="@/assets/icon21.png" class="icon-60 margin-top-120" @click="handleSmilingFace" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Definition",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    wordData: {
      type: Object,
      default: () => ({
        word: "pay",
        definition: "v.支付;偿还,缴纳;\n给予,致以"
      })
    },
    progress: {
      type: String,
      default: "0/30"
    },
    title: {
      type: String,
      default: "Unit 1"
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    playAudio() {
      this.$emit('play-audio', this.wordData);
    },
    nextWord() {
      this.$emit('next-word');
    },
    handleCryingFace() {
      this.$emit('crying-face');
    },
    handleSmilingFace() {
      this.$emit('smiling-face', this.wordData);
    }
  }
};
</script>
<style scoped>
.el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.7) !important;
}
</style>
<style scoped lang="scss">
::v-deep {

  .el-dialog__header,
  .el-dialog__body {
    padding: 0 !important;
  }

  .el-dialog {
    border-radius: 30px;
    background: transparent;
    box-shadow: none;
  }
}

.solid-bottom {
  border-bottom: 1px solid #2342c9;
}

.definition-content {
  white-space: pre-line;
  color: #001A8B;
}
</style>
